var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"col-6 col-md-3 mb-3"},[_c('strong',[_c('span',[_vm._v(_vm._s(_vm.title)+":")])]),_vm._v(" "),(_vm.value != '')?_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.value)}}),_vm._v(" "),_vm._t("default")],2):_c('div',[_c('span',[_vm._v("Keine Angabe")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }